import React from 'react';
import { BasicPage } from '../../../../shared/components/BasicPage';
import { PageLocation } from '../../../../shared/enum/PageLocation';
import { HomeContext } from '../../../Home/HomeContext';
import { DetachedClassificationInitial } from '../components/DetachedClassificationInitial';
import { DetachedClassificationFields } from '../components/DetachedClassificationFields';
import { InfluencerContext } from '../../NewsContext';
import { NewsModel } from '../../../../Models/NewsModel';
import { ErrorStatus } from '../../../../shared/enum/ErrorStatus';
import { InfluencerModel } from '../../../../Models/InfluencerModel';

export function DetachedClassification() {

    const homeContext = React.useContext(HomeContext);
    const newsContext = React.useContext(InfluencerContext);

    const [detachedClassificationInitial, setDetachedClassificationInitial] = React.useState<boolean>(true);

    React.useEffect(() => {
        if (homeContext.pageLocation === PageLocation.DETACHED_CLASSIFICATION_INITIAL
            || homeContext.pageLocation === PageLocation.DETACHED_CLASSIFICATION) {

            const news: InfluencerModel = JSON.parse(JSON.stringify(newsContext.news));
            news.detached = true;
            newsContext.setNews(news);
            newsContext.setErrorDataStatus(ErrorStatus.NOT_INICIALIZED);
            newsContext.setErrorCategorizationStatus(ErrorStatus.NOT_INICIALIZED);

            if (homeContext.pageLocation === PageLocation.DETACHED_CLASSIFICATION_INITIAL)
                setDetachedClassificationInitial(true);
            else
                setDetachedClassificationInitial(false);
        }
    }, [homeContext.pageLocation]);

    return (
        <BasicPage
            title={detachedClassificationInitial ? 'Classificação avulsa' : ''}
            subtitle={detachedClassificationInitial ? 'Para incluir uma nova matéria, insira os dados solicitados abaixo' : ''}>
            <>
                {detachedClassificationInitial && <DetachedClassificationInitial />}
                {!detachedClassificationInitial && <DetachedClassificationFields />}
            </>
        </BasicPage>
    );
}